import { Component, Input, OnInit } from '@angular/core';
import { SkillRepoEmployeesService } from '../../skill-repo-employees/skill-repo-employees.service';
import { ActivatedRoute } from '@angular/router';
import { CompetenciesService } from '../competencies.service';

@Component({
  selector: 'app-skill-maturity',
  templateUrl: './skill-maturity.component.html',
  styleUrls: ['./skill-maturity.component.css']
})
export class SkillMaturityComponent implements OnInit {

  @Input() cardWidth: string = '100%';
  @Input() paddingLeft: string = '8vw';
  @Input() paddingRight: string = '8vw';
  @Input() paddingBottom: string = '35px';
  @Input() rowGap: string = '3vw';
  @Input() columnGap: string = '6.85';
  @Input() cardColor: string = '#FFF';
  @Input() flag: boolean = false;
  @Input() checkFlag: boolean = false;
  @Input() skills: any;
  @Input() applyMinHeight: boolean = false;
  isCardOpen = true;
  Data = [
    { 'name': 'Resources', 'count': 20 },
    { 'name': 'SME', 'count': 20 },
    { 'name': 'Certifications', 'count': 20 },
  ];
  Domain = [
    { 'value': 'Communication, Media & Technology', 'name': 'CMT' },
    { 'value': 'Banking & Financial Services', 'name': 'BFS' },
    { 'value': 'Energy', 'name': 'Energy' },
    { 'value': 'Healthcare, Insurance & Life Sciences', 'name': 'HILS' },
    { 'value': 'Public Sector', 'name': 'Public Sector' },
    { 'value': 'Transportation, Travel & Hospitality', 'name': 'TTH' },
    { 'value': 'CPG & Retail', 'name': 'CPG & Retail' },
    { 'value': 'Manufacturing', 'name': 'Manufacturing' },

    { 'value': 'Supply Chain Management', 'name': 'SCM' },
    { 'value': 'Logistics', 'name': 'Logistics' },
  ]
  Paternships = [

    { 'value': 'AWS', 'name': 'Amazon Web Services' },
    { 'value': 'Microsoft', 'name': 'Microsoft' },
    { 'value': 'IBM', 'name': 'IBM' },
    { 'value': 'PEGA', 'name': 'PEGA' },
    { 'value': 'GCP', 'name': 'Google cloud platform' },
    { 'value': 'Automation', 'name': 'Automation Amywhere' },
    { 'value': 'Salesforce', 'name': 'Salesforce' },
    { 'value': 'Seceon', 'name': 'Seceon' },
    { 'value': 'SnowFlake', 'name': 'SnowFlake' },
    { 'value': 'Databricks', 'name': 'databricks' },
  ]


  constructor(private compservice: CompetenciesService, private route: ActivatedRoute, private service: SkillRepoEmployeesService) { }
  competencyId: number;

  ngOnInit() {

    this.compservice.profileStatus$.subscribe(x => {
      this.competencyId = x;
      this.getCompetencyLevelCounts(this.competencyId);
    })
  }

  toggleFlag() {
    this.compservice.toggleFlag();
  }

  getCompetencyLevelCounts(competencyId) {
    this.compservice.GetCompetencyLevelCounts(competencyId).subscribe(res => {
      this.skills = res.data;
    })
  }
}
